import { A11yModule } from "@angular/cdk/a11y";
import { OverlayModule } from "@angular/cdk/overlay";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { NgOptimizedImage } from "@angular/common";
import { NgModule } from "@angular/core";
import { CreateCollectionComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-organizations/create-collection.component";
import { OrganizationPageComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-organizations/organization-page.component";
import { AcceptTeamComponent } from "@bitwarden/web-vault/app/gloss/others/accept-team.component";
import { TeamDetailComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-organizations/team-detail.component";
import { TeamsInfoPanelComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-organizations/teams-info-panel.component";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatDividerModule } from "@angular/material/divider";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTableModule } from "@angular/material/table";
import { NgSelectModule } from "@ng-select/ng-select";
import { AgGridAngular } from "ag-grid-angular";

import { AccordionComponent } from "@bitwarden/web-vault/app/components/accordion/accordion.component";
import { StepperComponent as WizardStepperComponent } from "@bitwarden/web-vault/app/gloss/wizard/stepper/stepper.component";
import { AddBalanceWizardComponent } from "@bitwarden/web-vault/app/components/add-balance-wizard/add-balance-wizard.component";
import { FileDetailsStageComponent } from "@bitwarden/web-vault/app/components/add-balance-wizard/file-details-stage.component";
import { SelectAccountStageComponent } from "@bitwarden/web-vault/app/components/add-balance-wizard/select-account-stage.component";
import { AddTransactionStageComponent } from "@bitwarden/web-vault/app/components/add-balance-wizard/add-transaction-stage.component";
import { TabsWrapperComponent } from "@bitwarden/web-vault/app/components/tabs-wrapper/tabs-wrapper.component";
import { AddEditTransactionFormComponent } from "@bitwarden/web-vault/app/components/add-edit-transaction-form/add-edit-transaction-form.component";
import { AgGridTableComponent } from "@bitwarden/web-vault/app/components/ag-grid-table/ag-grid-table.component";
import { AutoCompleteTransactionDirectionComponent } from "@bitwarden/web-vault/app/components/auto-transaction-direction/auto-complete-transaction-direction.component";
import { BalanceChartComponent } from "@bitwarden/web-vault/app/components/charts/balance-chart/balance-chart.component";
import { BalanceHudComponent } from "@bitwarden/web-vault/app/components/balance-hud/balance-hud.component";
import { ScenarioChartComponent } from "@bitwarden/web-vault/app/components/charts/scenario-chart/scenario-chart.component";
import { ScenarioHudComponent } from "@bitwarden/web-vault/app/components/charts/scenario-chart/scenario-hud/scenario-hud.component";
import { BankIconsComponent } from "@bitwarden/web-vault/app/components/bank-icons/bank-icons.component";
import { InstalledPluginCardComponent } from "@bitwarden/web-vault/app/components/installed-plugin-card/installed-plugin-card.component";
import { SearchInputComponent } from "@bitwarden/web-vault/app/components/search-input/search-input.component";
import { PluginConfigComponent } from "@bitwarden/web-vault/app/components/plugin-config/plugin-config.component";
import { BestScenarioCarouselItemComponent } from "@bitwarden/web-vault/app/gloss/wizard/best-scenario-dialog/best-scenario-carousel-item/best-scenario-carousel-item.component";
import { BestScenarioDialogComponent } from "@bitwarden/web-vault/app/gloss/wizard/best-scenario-dialog/best-scenario-dialog.component";
import { MonthlySummaryDialogComponent } from "@bitwarden/web-vault/app/gloss/monthly-summary/monthly-summary-dialog.component";
import { GroceryHelpDialogComponent } from "@bitwarden/web-vault/app/gloss/gloss-grocery/grocery-help-dialog/grocery-help-dialog.component";
import { GroceryRowActionsSheetComponent } from "@bitwarden/web-vault/app/gloss/gloss-grocery/grocery-row-actions-sheet/grocery-row-actions-sheet.component";
import { BubbleChartComponent } from "@bitwarden/web-vault/app/components/charts/bubble-chart/bubble-chart.component";
import { ContributionGraphComponent } from "@bitwarden/web-vault/app/components/charts/contribution-graph/contribution-graph.component";
import { FulfillConditionsComponent } from "@bitwarden/web-vault/app/gloss/wizard/best-scenario-dialog/steps/fulfill-conditions/fulfill-conditions.component";
import { MoveAssetComponent } from "@bitwarden/web-vault/app/gloss/wizard/best-scenario-dialog/steps/move-asset/move-asset.component";
import { OpenAccountComponent } from "@bitwarden/web-vault/app/gloss/wizard/best-scenario-dialog/steps/open-account/open-account.component";
import { BestAccountTooltipComponent } from "@bitwarden/web-vault/app/gloss/wizard/best-scenario-dialog/views/best-account-tooltip/best-account-tooltip.component";
import { CarouselEarningsCardComponent } from "@bitwarden/web-vault/app/gloss/wizard/best-scenario-dialog/views/carousel-earnings-card/carousel-earnings-card.component";
import { CarouselRateConditionComponent } from "@bitwarden/web-vault/app/gloss/wizard/best-scenario-dialog/views/carousel-rate-condition/carousel-rate-condition.component";
import { EarningsCardComponent } from "@bitwarden/web-vault/app/gloss/wizard/best-scenario-dialog/views/earnings-card/earnings-card.component";
import { EarningsContentComponent } from "@bitwarden/web-vault/app/gloss/wizard/best-scenario-dialog/views/earnings-card/earnings-content/earnings-content.component";
import { EarningsFooterComponent } from "@bitwarden/web-vault/app/gloss/wizard/best-scenario-dialog/views/earnings-card/earnings-footer/earnings-footer.component";
import { EarningsHeaderComponent } from "@bitwarden/web-vault/app/gloss/wizard/best-scenario-dialog/views/earnings-card/earnings-header/earnings-header.component";
import { OpenAccountCardComponent } from "@bitwarden/web-vault/app/gloss/wizard/best-scenario-dialog/views/open-account-card/open-account-card.component";
import { StepperEarningsCardComponent } from "@bitwarden/web-vault/app/gloss/wizard/best-scenario-dialog/views/stepper-earnings-card/stepper-earnings-card.component";
import { TitleComponent } from "@bitwarden/web-vault/app/gloss/wizard/best-scenario-dialog/views/title/title.component";
import { TooltipCardComponent } from "@bitwarden/web-vault/app/gloss/wizard/best-scenario-dialog/views/tooltip-card/tooltip-card.component";
import { ButtonsModule } from "@bitwarden/web-vault/app/components/buttons/buttons.module";
import { GlossButtonComponent } from "@bitwarden/web-vault/app/components/buttons/gloss-button/gloss-button.component";
import { RadioButtonComponent } from "@bitwarden/web-vault/app/components/buttons/radio-button/radio-button.component";
import { TileButtonComponent } from "@bitwarden/web-vault/app/components/buttons/tile-button/tile-button.component";
import { CarouselComponent } from "@bitwarden/web-vault/app/components/carousel/carousel.component";
import { AccountActionButtonsCellRenderer } from "@bitwarden/web-vault/app/components/cell-renderers/account-action-buttons-renderer/account-action-buttons-cell-renderer.component";
import { AggregateAmountCellRenderer } from "@bitwarden/web-vault/app/components/cell-renderers/aggregate-amount-renderer/aggregate-amount-cell-renderer.component";
import { BalanceCellRenderer } from "@bitwarden/web-vault/app/components/cell-renderers/balance-renderer/balance-renderer.component";
import { BookCellRenderer } from "@bitwarden/web-vault/app/components/cell-renderers/book-renderer/book-renderer.component";
import { CategoryCellRenderer } from "@bitwarden/web-vault/app/components/cell-renderers/category-renderer/category-renderer.component";
import { CheckBoxCellRenderer } from "@bitwarden/web-vault/app/components/cell-renderers/check-box-renderer/check-box-cell-renderer.component";
import { ClassificationCellRenderer } from "@bitwarden/web-vault/app/components/cell-renderers/classification-renderer/classification-renderer.component";
import { InAmountCellRenderer } from "@bitwarden/web-vault/app/components/cell-renderers/in-amount-renderer/in-amount-cell-renderer.component";
import { NoRowsOverlayComponentOfDashTable } from "@bitwarden/web-vault/app/components/cell-renderers/no-rows-overlay-component-of-dash-table/no-rows-overlay-component-of-dash-table.component";
import { NormalizedInAmountCellRenderer } from "@bitwarden/web-vault/app/components/cell-renderers/normalized-in-amount-renderer/normalized-in-amount-cell-renderer.component";
import { NormalizedOutAmountCellRenderer } from "@bitwarden/web-vault/app/components/cell-renderers/normalized-out-amount-renderer/normalized-out-amount-cell-renderer.component";
import { OutAmountCellRenderer } from "@bitwarden/web-vault/app/components/cell-renderers/out-amount-renderer/out-amount-renderer.component";
import { ProductCellRenderer } from "@bitwarden/web-vault/app/components/cell-renderers/product-cell-renderer/product-renderer.component";
import { SyncStatusRendererComponent } from "@bitwarden/web-vault/app/components/cell-renderers/sync-status-renderer/sync-status-renderer.component";
import { TransactionDateCellRender } from "@bitwarden/web-vault/app/components/cell-renderers/transaction-date-cell-renderer/transaction-date-cell-renderer.component";
import { CheckboxComponent } from "@bitwarden/web-vault/app/components/checkbox/checkbox.component";
import { FilterSectionComponent } from "@bitwarden/web-vault/app/components/filter-section/filter-section.component";
import { PluginCardComponent } from "@bitwarden/web-vault/app/components/plugin-card/plugin-card.component";
import { PluginDetailsDialogComponent } from "@bitwarden/web-vault/app/gloss/plugins/plugin-details-dialog/plugin-details-dialog.component";
import { EditToolsDialogComponent } from "@bitwarden/web-vault/app/gloss/plugins/edit-tools-dialog/edit-tools-dialog.component";
import { WealthComparisonDialogComponent } from "@bitwarden/web-vault/app/gloss/plugins/wealth-comparison/wealth-comparison-dialog.component";
import { ConfirmationDialogComponent } from "@bitwarden/web-vault/app/components/confirmation-dialog/confirmation-dialog.component";
import { StatusHeaderComponent } from "@bitwarden/web-vault/app/components/status-header/status-header.component";
import { AlertDialogComponent } from "@bitwarden/web-vault/app/gloss/settings/manage-security/emergency-access/alert-dialog/alert-dialog.component";
import { CountriesComponent } from "@bitwarden/web-vault/app/components/countries/countries.component";
import { CurrenciesComponent } from "@bitwarden/web-vault/app/components/currencies/currencies.component";
import { SearchBarComponent } from "@bitwarden/web-vault/app/components/search-bar/search-bar.component";
import { EditBalanceComponent } from "@bitwarden/web-vault/app/gloss/wizard/edit-balance/edit-balance.component";
import { FilePreviewComponent } from "@bitwarden/web-vault/app/components/file-upload/file-preview/file-preview.component";
import { FileFullPreviewComponent } from "@bitwarden/web-vault/app/components/file-upload/file-full-preview/file-full-preview.component";
import { FileUploadComponent } from "@bitwarden/web-vault/app/components/file-upload/file-upload.component";
import { CalloutComponent } from "@bitwarden/web-vault/app/components/callout/callout.component";
import { ViewsDropdownComponent } from "@bitwarden/web-vault/app/gloss/views/views-control/views-dropdown/views-dropdown.component";
import { DropdownSelectComponent } from "@bitwarden/web-vault/app/components/dropdown/dropdown-select/dropdown-select.component";
import { DropdownSearchComponent } from "@bitwarden/web-vault/app/components/dropdown/dropdown-search.component";
import { DropdownMultiselectComponent } from "@bitwarden/web-vault/app/components/dropdown/dropdown-multiselect.component";
import { CategorySelectComponent } from "@bitwarden/web-vault/app/components/category-select/category-select.component";
import { DateFieldComponent } from "@bitwarden/web-vault/app/components/date-field/date-field.component";
import { DropdownExpandComponent } from "@bitwarden/web-vault/app/components/dropdown/dropdown-expand.component";
import { GlossInputComponent } from "@bitwarden/web-vault/app/components/inputs/gloss-input/gloss-input.component";
import { InputComponent } from "@bitwarden/web-vault/app/components/inputs/input/input.component";
import { PasswordInputComponent } from "@bitwarden/web-vault/app/components/inputs/password-input/password-input.component";
import { InstitutionalAccountsComponent } from "@bitwarden/web-vault/app/components/institutional-accounts/institutional-accounts.component";
import { ModalFooterComponent } from "@bitwarden/web-vault/app/components/modal/modal-footer.component";
import { ModalHeaderComponent } from "@bitwarden/web-vault/app/components/modal/modal-header.component";
import { NavPanelComponent } from "@bitwarden/web-vault/app/components/nav-panel/nav-panel.component";
import { BasiqProgressBarComponent } from "@bitwarden/web-vault/app/components/progress-bar/basiq-progress-bar/basiq-progress-bar.component";
import { ProgressBarComponent } from "@bitwarden/web-vault/app/components/progress-bar/progress-bar.component";
import { ReferenceDataImportComponent } from "@bitwarden/web-vault/app/components/reference-data-import/reference-data-import.component";
import { ScenarioDifferenceMessageComponent } from "@bitwarden/web-vault/app/components/scenario-difference-message/scenario-difference-message.component";
import { SpinnerComponent } from "@bitwarden/web-vault/app/components/spinner/spinner.component";
import { StepIndicatorComponent } from "@bitwarden/web-vault/app/components/stepper/step-indicator/step-indicator.component";
import { StepperComponent } from "@bitwarden/web-vault/app/components/stepper/stepper.component";
import { PathTabsComponent } from "@bitwarden/web-vault/app/gloss/views/future-view/path-tabs/path-tabs.component";
import { ToggleSwitchComponent } from "@bitwarden/web-vault/app/components/toggle-switch/toggle-switch.component";
import { SwitchToggleComponent } from "@bitwarden/web-vault/app/components/switch-toggle/switch-toggle.component";
import { CurrencyAmountInputComponent } from "@bitwarden/web-vault/app/components/currency-amount-input/currency-amount-input.component";
import { BestInterestAccountComponent } from "@bitwarden/web-vault/app/components/tooltips/best-interest-account/best-interest-account.component";
import { HelpTooltipComponent } from "@bitwarden/web-vault/app/components/tooltips/help-tooltip/help-tooltip.component";
import { TooltipIconComponent } from "@bitwarden/web-vault/app/components/tooltips/tooltip-icon.component";
import { WidgetComponent } from "@bitwarden/web-vault/app/components/widget/widget.component";
import { CabinetFileUploadComponent } from "@bitwarden/web-vault/app/gloss/cabinet/cabinet-file-upload/cabinet-file-upload.component";
import { StatementImportMappingComponent } from "@bitwarden/web-vault/app/gloss/cabinet/statement-import-mapping/statement-import-mapping.component";
import { EditCabinetComponent } from "@bitwarden/web-vault/app/gloss/cabinet/edit-cabinet/edit-cabinet.component";
import { DisplayTransactionsComponent } from "@bitwarden/web-vault/app/gloss/cabinet/components/display-transactions/display-transactions.component";
import { ItemDisplayComponent } from "@bitwarden/web-vault/app/gloss/cabinet/components/item-display/item-display.component";
import { ComingSoonPageComponent } from "@bitwarden/web-vault/app/gloss/coming-soon-page/coming-soon-page.component";
import { HelpBoxComponent } from "@bitwarden/web-vault/app/gloss/help-box/help-box.component";
import { TransactionDetailsComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/transaction-details/transaction-details.component";
import { LinkTransactionPickerComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/transaction-details/link-transaction-picker.component";
import { EditTransactionDetailsComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/edit-transaction-details/edit-transaction-details.component";
import { BalanceAlignmentTransactionComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/balance-alignment-transaction/balance-alignment-transaction.component";
import { StatementBalanceDetailsComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/statement-balance-details/statement-balance-details.component";
import { RevaluationTransactionComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/revaluation-transaction/revaluation-transaction.component";
import { EstimateFormComponent } from "@bitwarden/web-vault/app/gloss/estimates/estimates-add-edit/estimate/estimate-form.component";
import { EstimateTypeInterestComponent } from "@bitwarden/web-vault/app/gloss/estimates/estimates-add-edit/estimate/estimate-type-interest/estimate-type-interest.component";
import { EstimateTypeRecurringComponent } from "@bitwarden/web-vault/app/gloss/estimates/estimates-add-edit/estimate/estimate-type-recurring/estimate-type-recurring.component";
import { EstimateTypeRevaluationComponent } from "@bitwarden/web-vault/app/gloss/estimates/estimates-add-edit/estimate/estimate-type-revaluation/estimate-type-revaluation.component";
import { EstimateTypeTransactionComponent } from "@bitwarden/web-vault/app/gloss/estimates/estimates-add-edit/estimate/estimate-type-transaction/estimate-type-transaction.component";
import { AccountBalanceComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/account-balance/account-balance.component";
import { AccountRegionsComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/account-regions/account-regions.component";
import { AccountAddEditComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/accounts-add-edit/account-add-edit.component";
import { AccountTypeComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/account-type/account-type.component";
import { AccountSyncComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/account-sync/account-sync.component";
import { ManageAccountsComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/manage-accounts.component";
import { AccountRowSkeletonComponent } from "@bitwarden/web-vault/app/gloss/components/account-row-skeleton/account-row-skeleton.component";
import { LoadingAnnouncerComponent } from "@bitwarden/web-vault/app/gloss/components/loading-announcer/loading-announcer.component";
import { LargeAmountComponent } from "@bitwarden/web-vault/app/components/large-amount/large-amount.component";
import { GlossScrollComponent } from "@bitwarden/web-vault/app/components/gloss-scroll/gloss-scroll.component";
import { LinkTypeBadgeComponent } from "@bitwarden/web-vault/app/components/link-type-badge/link-type-badge.component";
import { BudgetComponent } from "@bitwarden/web-vault/app/gloss/budget/budget.component";
import { CreditsComponent } from "@bitwarden/web-vault/app/gloss/credits/credits.component";
import { HelpGuideComponent } from "@bitwarden/web-vault/app/gloss/help-guide/help-guide.component";
import { GuideComponent } from "@bitwarden/web-vault/app/gloss/help-guide/guide/guide.component";
import { CouponsComponent } from "@bitwarden/web-vault/app/gloss/coupons/coupon.component";
import { CouponCardComponent } from "../components/coupon-card/coupon-card.component";
import { PluginsComponent } from "@bitwarden/web-vault/app/gloss/plugins/plugins.component";
import { GlossGroceryComponent } from "@bitwarden/web-vault/app/gloss/gloss-grocery/gloss-grocery.component";
import { RenameListDialogComponent } from "@bitwarden/web-vault/app/gloss/gloss-grocery/rename-list-dialog/rename-list-dialog.component";
import { CabinetComponent } from "@bitwarden/web-vault/app/gloss/cabinet/cabinet.component";
import { ManageSymbolsComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-symbols/manage-symbols.component";
import { TransactionComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/transaction/transaction.component";
import { CategoriesAddEditComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-categories/categories-add-edit/categories-add-edit.component";
import { CollapsibleCardComponent } from "@bitwarden/web-vault/app/gloss/credits/components/collapsible-card/collapsible-card.component";
import { TotalCreditsDisplayComponent } from "@bitwarden/web-vault/app/gloss/credits/components/total-credits-display/total-credits-display.component";
import { PlatinumCardComponent } from "@bitwarden/web-vault/app/gloss/credits/components/platinum-card/platinum-card.component";
import { PointsRedemptionComponent } from "@bitwarden/web-vault/app/gloss/credits/components/points-redemption/points-redemption.component";
import { AmazonGiftCardComponent } from "@bitwarden/web-vault/app/gloss/credits/components/amazon-gift-card/amazon-gift-card.component";
import { PointsPurchaseComponent } from "@bitwarden/web-vault/app/gloss/credits/components/points-purchase/points-purchase.component";
import { CreditsAddedComponent } from "@bitwarden/web-vault/app/gloss/credits/components/credits-added/credits-added.component";
import { PurchaseProcessingComponent } from "@bitwarden/web-vault/app/gloss/credits/components/purchase-processing/purchase-processing.component";
import { RecentActivityComponent } from "@bitwarden/web-vault/app/gloss/credits/components/recent-activity/recent-activity.component";
import { AdListComponent } from "@bitwarden/web-vault/app/gloss/credits/components/ad-list/ad-list.component";
import { DesktopAdModalComponent } from "@bitwarden/web-vault/app/gloss/credits/components/ad-list/desktop-ad-modal/desktop-ad-modal.component";
import { RedemptionConfirmationComponent } from "@bitwarden/web-vault/app/gloss/credits/components/points-redemption/components/redemption-confirmation/redemption-confirmation.component";
import { TabButtonComponent } from "@bitwarden/web-vault/app/gloss/credits/components/tab-button/tab-button.component";
import { ConversionConfirmationComponent } from "@bitwarden/web-vault/app/gloss/credits/components/gold-platinum-converter/components/conversion-confirmation/conversion-confirmation.component";
import { ManageCategoriesComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-categories/manage-categories.component";
import { ClassificationAddEditComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-classifications/classification-add-edit/classification-add-edit.component";
import { ManageClassificationsComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-classifications/manage-classifications.component";
import { ClassificationsDetailsComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-classifications/classifications-details/classifications-details.component";
import { ManageInstitutionsComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-institutions/manage-institutions.component";
import { ManageSourceExplorerComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-source-explorer/manage-source-explorer.component";
import { AutoRedemptionTestPanelComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-source-explorer/auto-redemption-test-panel/auto-redemption-test-panel.component";
import { VaultDuplicateItemsDialogComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-source-explorer/vault-duplicate-items-dialog.component";
import { VaultTypeGenericComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-source-explorer/data-types/vault-type-generic/vault-type-generic.component";
import { VaultTypeTransactionComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-source-explorer/data-types/vault-type-transaction/vault-type-transaction.component";
import { VaultTypeSourceTransactionComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-source-explorer/data-types/vault-type-source-transaction/vault-type-source-transaction.component";
import { VaultTypeAccountComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-source-explorer/data-types/vault-type-account/vault-type-account.component";
import { ManagePreferencesComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-preferences/manage-preferences.component";
import { AutoCreditRedemptionToggleComponent } from "@bitwarden/web-vault/app/components/auto-credit-redemption-toggle/auto-credit-redemption-toggle.component";
import { TransactionDescriptionCellRenderer } from "@bitwarden/web-vault/app/components/tables/renderers/cell/transaction-desc-renderer/transaction-desc-renderer.component";
import { AmountRendererComponent } from "@bitwarden/web-vault/app/components/tables/renderers/cell/amount-renderer/amount-renderer.component";
import { AccountIconRendererComponent } from "@bitwarden/web-vault/app/components/tables/renderers/cell/account-icon-renderer/account-icon-renderer.component";
import { TableCellNameRendererComponent } from "@bitwarden/web-vault/app/components/tables/renderers/cell/account-name-renderer/table-cell-name-renderer.component";
import { CategoryItemRenderComponent } from "@bitwarden/web-vault/app/components/tables/renderers/cell/category-item-renderer/category-item-render.component";
import { CategorySourceRendererComponent } from "@bitwarden/web-vault/app/components/tables/renderers/cell/category-source-renderer/category-source-renderer.component";
import { CategorySourceBadgeComponent } from "@bitwarden/web-vault/app/components/category-source-badge/category-source-badge.component";
import { ClassificationItemRenderComponent } from "@bitwarden/web-vault/app/components/tables/renderers/cell/classification-item-renderer/classification-item-render.component";
import { SymbolRateRendererComponent } from "@bitwarden/web-vault/app/components/tables/renderers/cell/symbol-rate-renderer/symbol-rate-renderer.component";
import { AccountStatusRendererComponent } from "@bitwarden/web-vault/app/components/tables/renderers/cell/account-status-renderer/account-status-renderer.component";
import { ViewsComponent } from "@bitwarden/web-vault/app/gloss/views/views.component";
import { AccountsFilterComponent } from "@bitwarden/web-vault/app/gloss/views/accounts/accounts-filter.component";
import { SideMenuComponent } from "@bitwarden/web-vault/app/layouts/menu/side-menu/side-menu.component";
import { MenuToggleComponent } from "@bitwarden/web-vault/app/layouts/menu/menu-toggle/menu-toggle.component";
import { ScrollArrowsComponent } from "@bitwarden/web-vault/app/components/scroll-arrows/scroll-arrows.component";
import { AppMenuComponent } from "@bitwarden/web-vault/app/layouts/menu/app-menu/app-menu.component";
import { MobileNavModule } from "@bitwarden/web-vault/app/layouts/menu/mobile-nav.module";
import { BookPipe } from "@bitwarden/web-vault/app/pipes/book.pipe";
import { CapitalisePipe } from "@bitwarden/web-vault/app/pipes/capitalise.pipe";
import { CategoryPipe } from "@bitwarden/web-vault/app/pipes/category.pipe";
import { ClassificationPipe } from "@bitwarden/web-vault/app/pipes/classification.pipe";
import { EstimatePipe } from "@bitwarden/web-vault/app/pipes/estimate.pipe";
import { SafeHtmlPipe } from "@bitwarden/web-vault/app/pipes/safe-html.pipe";
import { ChangePasswordComponent } from "@bitwarden/web-vault/app/gloss/settings/manage-security/change-password/change-password.component";
import { EmergencyAccessComponent } from "@bitwarden/web-vault/app/gloss/settings/manage-security/emergency-access/emergency-access.component";
import { ManageSecurityComponent } from "@bitwarden/web-vault/app/gloss/settings/manage-security/manage-security.component";
import { ConfirmConsentRemovalComponent } from "@bitwarden/web-vault/app/gloss/settings/remove-basiq-consent/confirm-consent-removal/confirm-consent-removal.component";
import { RemoveBasiqConsentComponent } from "@bitwarden/web-vault/app/gloss/settings/remove-basiq-consent/remove-basiq-consent.component";
import { RemoveFiskilConsentComponent } from "@bitwarden/web-vault/app/gloss/settings/remove-fiskil-consent/remove-fiskil-consent.component";
import { SettingsRouteComponent } from "@bitwarden/web-vault/app/gloss/settings/settings-route.component";
import { SettingsComponent } from "@bitwarden/web-vault/app/gloss/settings/settings.component";

import { DateFormatPipe } from "../../app/pipes/date-format.pipe";
import { HintComponent } from "@bitwarden/web-vault/app/gloss/hint/hint.component";
import { IosRedemptionBoxComponent } from "@bitwarden/web-vault/app/gloss/ios-redemption-box/ios-redemption-box.component";
import { LockComponent } from "@bitwarden/web-vault/app/gloss/lock/lock.component";
import { AcceptEmergencyComponent } from "@bitwarden/web-vault/app/gloss/others/accept-emergency.component";
import { RecoverDeleteComponent } from "@bitwarden/web-vault/app/gloss/others/recover-delete.component";
import { RecoverTwoFactorComponent } from "@bitwarden/web-vault/app/gloss/others/recover-two-factor.component";
import { DeviceApprovalRequiredComponent } from "@bitwarden/web-vault/app/gloss/others/device-approval-required.component";
import { PendingDeviceApprovalDialogComponent } from "@bitwarden/web-vault/app/gloss/others/pending-device-approval-dialog.component";
import { FirstDeviceSetupComponent } from "@bitwarden/web-vault/app/gloss/others/first-device-setup.component";
import { RemovePasswordComponent } from "@bitwarden/web-vault/app/gloss/others/remove-password.component";
import { SetPasswordComponent } from "@bitwarden/web-vault/app/gloss/others/set-password.component";
import { TwoFactorOptionsComponent } from "@bitwarden/web-vault/app/gloss/others/two-factor-options.component";
import { TwoFactorComponent } from "@bitwarden/web-vault/app/gloss/others/two-factor.component";
import { UpdatePasswordComponent } from "@bitwarden/web-vault/app/gloss/others/update-password.component";
import { VerifyEmailTokenComponent } from "@bitwarden/web-vault/app/gloss/others/verify-email-token.component";
import { PresetDateRangeComponent } from "../components/date-range-picker/preset-date-range/preset-date-range.component";
import { CalendarComponent } from "@bitwarden/web-vault/app/components/date-picker/calendar/calendar.component";
import { DatePickerComponent } from "@bitwarden/web-vault/app/components/date-picker/date-picker.component";
import { MorphOverlayDirective } from "@bitwarden/web-vault/app/directives/morph-overlay.directive";
import { MainProgressBarComponent } from "../components/progress-bar/main-progress-bar/main-progress-bar.component";
import { UserLocationComponent } from "@bitwarden/web-vault/app/gloss/user-location/user-location.component";
import { UserVerificationPromptComponent } from "../components/user-verification-prompt.component";
import { UserVerificationComponent } from "../components/user-verification.component";
import { EstimatesAddEditComponent } from "../gloss/estimates/estimates-add-edit/estimates-add-edit.component";
import { EstimatesComponent } from "../gloss/estimates/estimates.component";
import { FrontendLayoutComponent } from "../layouts/frontend-layout.component";
import { ViewsControlComponent } from "../gloss/views/views-control/views-control.component";
import { ViewsCustomizeComponent } from "@bitwarden/web-vault/app/gloss/views/views-control/views-customize/views-customize.component";
import { UserLayoutComponent } from "../layouts/user-layout.component";
import { ProvidersComponent } from "../providers/providers.component";
import { AdvancedFeaturesComponent } from "@bitwarden/web-vault/app/gloss/settings/advanced-features/advanced-features.component";
import { BillAlertDialogComponent } from "@bitwarden/web-vault/app/gloss/settings/notifications/bill-alert-dialog.component";
import { NotificationsComponent } from "@bitwarden/web-vault/app/gloss/settings/notifications/notifications.component";
import { ApiKeyComponent } from "@bitwarden/web-vault/app/gloss/settings/api-key.component";
import { ChangeEmailComponent } from "@bitwarden/web-vault/app/gloss/settings/change-email.component";
import { ChangeKdfComponent } from "@bitwarden/web-vault/app/gloss/settings/change-kdf.component";
import { DeauthorizeSessionsComponent } from "@bitwarden/web-vault/app/gloss/settings/deauthorize-sessions.component";
import { DeleteAccountComponent } from "@bitwarden/web-vault/app/gloss/settings/delete-account.component";

import { PreferencesComponent } from "@bitwarden/web-vault/app/gloss/settings/preferences.component";
import { ProfileComponent } from "@bitwarden/web-vault/app/gloss/settings/profile.component";
import { PurgeVaultComponent } from "@bitwarden/web-vault/app/gloss/settings/purge-vault.component";
import { SecurityKeysComponent } from "@bitwarden/web-vault/app/gloss/settings/security-keys.component";
import { TaxInfoComponent } from "@bitwarden/web-vault/app/gloss/settings/tax-info.component";
import { TwoFactorAuthenticatorComponent } from "@bitwarden/web-vault/app/gloss/settings/two-factor-authenticator.component";
import { TwoFactorEmailComponent } from "@bitwarden/web-vault/app/gloss/settings/two-factor-email.component";
import { TwoFactorManageComponent } from "@bitwarden/web-vault/app/gloss/settings/two-factor-manage.component";
import { TwoFactorRecoveryComponent } from "@bitwarden/web-vault/app/gloss/settings/two-factor-recovery.component";
import { TwoFactorSetupComponent } from "@bitwarden/web-vault/app/gloss/settings/two-factor-setup.component";
import { TwoFactorVerifyComponent } from "@bitwarden/web-vault/app/gloss/settings/two-factor-verify.component";
import { TwoFactorWebAuthnComponent } from "@bitwarden/web-vault/app/gloss/settings/two-factor-webauthn.component";
import { TwoFactorYubiKeyComponent } from "@bitwarden/web-vault/app/gloss/settings/two-factor-yubikey.component";
import { UpdateKeyComponent } from "@bitwarden/web-vault/app/gloss/settings/update-key.component";
import { UpdateLicenseComponent } from "@bitwarden/web-vault/app/gloss/settings/update-license.component";
import { UserAccessPageComponent } from "@bitwarden/web-vault/app/gloss/settings/access/user-access/user-access-page.component";
import { VaultTimeoutInputComponent } from "@bitwarden/web-vault/app/gloss/settings/vault-timeout-input.component";
import { VerifyEmailComponent } from "@bitwarden/web-vault/app/gloss/settings/verify-email.component";
import { GeneratorComponent } from "../tools/generator.component";
import { PasswordGeneratorHistoryComponent } from "../tools/password-generator-history.component";
import { ToolsComponent } from "../tools/tools.component";

import { SharedModule } from ".";
import { LoadingOverlayComponent } from "@bitwarden/web-vault/app/components/loading-overlay/loading-overlay.component";
import { AccountDetailsComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/account-details/account-details.component";
import { AccountListItemComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/account-list-item/account-list-item.component";
import { AccountOverviewHeroComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/account-overview/account-overview-hero.component";
import { AccountOverviewStripComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/account-overview/account-overview-strip.component";
import { SelectionPointerComponent } from "@bitwarden/web-vault/app/components/selection-pointer/selection-pointer.component";
import { AccountLinkedCollectionComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/account-linked-collection/account-linked-collection.component";
import { ShareAccountComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/share-account/share-account.component";
import { BudgetDetailsComponent } from "@bitwarden/web-vault/app/gloss/budget/budget-details/budget-details.component";
import { BudgetProgressBarComponent } from "@bitwarden/web-vault/app/gloss/budget/budget-progress-bar/budget-progress-bar.component";
import { CabinetDetailsComponent } from "@bitwarden/web-vault/app/gloss/cabinet/cabinet-details/cabinet-details.component";
import { AccountFormComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/account-form/account-form.component";
import { CabinetFormComponent } from "@bitwarden/web-vault/app/gloss/cabinet/cabinet-form/cabinet-form.component";
import { CurrentBalanceComponent } from "@bitwarden/web-vault/app/gloss/views/current-balance/current-balance";
import { GroupByChartControlComponent } from "@bitwarden/web-vault/app/gloss/views/groupby-chart-control/group-by-chart-control";
import { SymbolDetailsComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-symbols/symbol-details/symbol-details.component";
import { InstitutionDetailsComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-institutions/institution-details/institution-details.component";
import { AddSymbolFormComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-symbols/symbol-form/add-symbol-form.component";
import { EditSymbolFormComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-symbols/symbol-form/edit-symbol-form.component";
import { InstitutionFormComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-institutions/institution-form/institution-form.component";
import { MacroNumberPipe } from "@bitwarden/web-vault/app/pipes/macro-number.pipe";
import { DialogWrapperComponent } from "@bitwarden/web-vault/app/components/wrappers/dialog-wrapper/dialog-wrapper.component";
import { AsterisksPipe } from "@bitwarden/web-vault/app/pipes/asterisks.pipe";
import { StorageLimitPipe } from "@bitwarden/web-vault/app/pipes/storage-limit.pipe";
import { PastViewsDatepickerComponent } from "@bitwarden/web-vault/app/gloss/views/views-control/views-datepicker/past-views-datepicker/past-views-datepicker.component";
import { FutureViewsDatepickerComponent } from "@bitwarden/web-vault/app/gloss/views/views-control/views-datepicker/future-views-datepicker/future-views-datepicker.component";
import { TodayViewsDatepickerComponent } from "@bitwarden/web-vault/app/gloss/views/views-control/views-datepicker/today-views-datepicker/today-views-datepicker.component";
import { CabinetDatepickerComponent } from "@bitwarden/web-vault/app/gloss/cabinet/cabinet-datepicker/cabinet-datepicker.component";
import { DetailsWrapperComponent } from "@bitwarden/web-vault/app/components/wrappers/details-wrapper/details-wrapper.component";
import { PlansComponent } from "@bitwarden/web-vault/app/gloss/settings/access/plans/plans.component";
import { PlansFilterComponent } from "@bitwarden/web-vault/app/gloss/settings/access/plans/plans-filter.component";
import { PlanDetailsDialogComponent } from "@bitwarden/web-vault/app/gloss/settings/access/plans/plan-details-dialog/plan-details-dialog.component";
import { ChangePlanDialogComponent } from "@bitwarden/web-vault/app/gloss/settings/access/plans/change-plan-dialog/change-plan-dialog.component";
import { SubscriptionPageComponent } from "@bitwarden/web-vault/app/gloss/settings/access/subscription/subscription.component";
import { StorageComponent } from "@bitwarden/web-vault/app/gloss/settings/storage/storage.component";
import { MeterComponent } from "@bitwarden/web-vault/app/components/meter/meter.component";
import { PathTabsInfoComponent } from "@bitwarden/web-vault/app/gloss/views/future-view/path-tabs-info/path-tabs-info.component";
import { BalanceDetailsRendererComponent } from "@bitwarden/web-vault/app/components/tables/renderers/cell/balance-details-renderer/balance-details-renderer.component";
import { TransactionInfoPanelComponent } from "@bitwarden/web-vault/app/components/tables/renderers/row-detail/transaction-info-panel/transaction-info-panel.component";
import { ChevronCellRenderer } from "@bitwarden/web-vault/app/components/tables/renderers/cell/end-icon-renderer/end-icon-renderer.component";
import { CallToPremiumComponent } from "@bitwarden/web-vault/app/components/call-to-premium/call-to-premium.component";
import { CtaNotificationComponent } from "@bitwarden/web-vault/app/components/cta-notification/cta-notification.component";
import { SignalGlowWrapperComponent } from "@bitwarden/web-vault/app/components/wrappers/signal-glow-wraper/signal-glow-wrapper.component";
import { PriceDetailsComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-symbols/price-details/price-details.component";
import { NumberRollUpWrapperComponent } from "@bitwarden/web-vault/app/components/animation/number-roll-up-wrapper/number-roll-up-wrapper.component";
import { OdometerNumberComponent } from "@bitwarden/web-vault/app/components/animation/odometer-number/odometer-number.component";
import { CardGlareComponent } from "@bitwarden/web-vault/app/components/animation/card-glare/card-glare.component";
import { PremiumCalloutComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-symbols/symbol-form/premium-callout/premium-callout.component";
import { PageWrapperComponent } from "@bitwarden/web-vault/app/components/wrappers/page-wrapper/page-wrapper.component";
import { PastGroupHeaderComponent } from "@bitwarden/web-vault/app/components/tables/renderers/row-group/transaction-table/past-transaction-table/past-group-header.component";
import { VerifyEmailRemindDialogComponent } from "@bitwarden/angular/components/verify-email-remind-dialog.component";
import { ManuallyAddInstitutionComponent } from "@bitwarden/web-vault/app/components/manually-add-institution/manually-add-institution.component";
import { EarnComponent } from "@bitwarden/web-vault/app/gloss/earn/earn.component";
import { RedactionDescriptionRenderer } from "@bitwarden/web-vault/app/components/tables/earn-tables/renderers/description/description.cell-renderer";
import { VarianceCellRenderer } from "@bitwarden/web-vault/app/components/tables/budget-tables/budget-history-table/renderers/variance.cell-renderer.component";
import { RedactionPublishDateRenderer } from "@bitwarden/web-vault/app/components/tables/earn-tables/renderers/publish-date/publish-date.cell-renderer";
import { VersionHistoryComponent } from "@bitwarden/web-vault/app/gloss/earn/version-history/version-history.component";
import { CreateAndPublishComponent } from "@bitwarden/web-vault/app/gloss/earn/create-and-publish/create-and-publish.component";
import { CheckboxHeaderRenderer } from "@bitwarden/web-vault/app/components/tables/earn-tables/renderers/header/header.renderer";
import { CheckboxCellRenderer } from "@bitwarden/web-vault/app/components/tables/earn-tables/renderers/select-all/checkbox.cell-renderer";
import { SelectAllHeaderRenderer } from "@bitwarden/web-vault/app/components/tables/earn-tables/renderers/select-all/select-all-header.renderer";
import { ManageCellRendererComponent } from "@bitwarden/web-vault/app/components/tables/earn-tables/renderers/manage-version/manage-cell.renderer";
import { VersionStateCellRenderer } from "@bitwarden/web-vault/app/components/tables/earn-tables/renderers/version-state/version-state.renderer";
import { VersionGroupCellRenderer } from "@bitwarden/web-vault/app/components/tables/earn-tables/renderers/version-group/version-group.renderer";
import { AddBudgetFormComponent } from "../gloss/budget/budget-form/add-budget-form.component";
import { AutoBudgetPreviewDialogComponent } from "../gloss/plugins/auto-budget/auto-budget-preview-dialog/auto-budget-preview-dialog.component";
import { BudgetNameRendererComponent } from "../components/tables/renderers/cell/budget-name-renderer/budget-name-renderer.component";
import { CategoriesDetailsComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-categories/categories-details/categories-details.component";
import { CouponDetailsDialogComponent } from "@bitwarden/web-vault/app/gloss/coupons/coupon-details-dialog/coupon-details-dialog.component";
import { KeychainComponent } from "@bitwarden/web-vault/app/gloss/settings/keychain.component";
import { TaskInfoTooltipsComponent } from "@bitwarden/web-vault/app/components/task-info-tooltips/task-info-tooltips.component";
import { GuideSuccessToastComponent } from "@bitwarden/web-vault/app/components/guide-success-toast/guide-success-toast.component";
import { PullToRefreshDirective } from "@bitwarden/web-vault/app/directives/pull-to-refresh.directive";
import { ElasticScrollDirective } from "@vault/web-vault/app/directives/elastic-scroll.directive";
import { OverlayPanelDirective } from "@bitwarden/web-vault/app/directives/overlay-panel.directive";
import { FitLevelDirective } from "@bitwarden/web-vault/app/directives/fit-level.directive";
import { PrimaryNavArrowKeysDirective } from "@bitwarden/web-vault/app/directives/primary-nav-arrow-keys.directive";
import { ModalOverlayDirective } from "@bitwarden/web-vault/app/directives/modal-overlay.directive";
import { ChatbotComponent } from "../gloss/settings/chatbot/chatbot.component";
import { EmptyStateComponent } from "@vault/web-vault/app/components/empty-state/empty-state.component";
import { RecurringDetectorComponent } from "../gloss/plugins/recurring-detector/recurring-detector.component";
import { RecurringDetectorDetailDialogComponent } from "../gloss/plugins/recurring-detector/recurring-detector-detail-dialog.component";
import { SymbolIconRendererComponent } from "@bitwarden/web-vault/app/components/tables/renderers/cell/symbol-icon-renderer/symbol-icon-renderer.component";
import {
  RdActionRendererComponent,
  RdAvgAmountRendererComponent,
  RdChangeRendererComponent,
  RdDescriptionRendererComponent,
  RdNextDueRendererComponent,
  RdStatusRendererComponent,
} from "@bitwarden/web-vault/app/gloss/plugins/recurring-detector/recurring-detector-renderers";
import { GlossScrollDirective } from "@bitwarden/web-vault/app/components/gloss-scroll/gloss-scroll.directive";
import { GlossScrollGridDirective } from "@bitwarden/web-vault/app/components/gloss-scroll/gloss-scroll-grid.directive";

// Please do not add to this list of declarations - we should refactor these into modules when doing so makes sense
// until there are none left.
// If you are building new functionality, please create or extend a feature module instead.
@NgModule({
  imports: [
    GlossScrollDirective,
    GlossScrollGridDirective,
    SharedModule,
    OverlayModule,
    ScrollingModule,
    A11yModule,
    MatSlideToggleModule,
    MatTableModule,
    MatButtonModule,
    MatInputModule,
    MatPaginatorModule,
    MatCardModule,
    MatDividerModule,
    MatMenuModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatFormFieldModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    NgSelectModule,
    AgGridAngular,
    NgOptimizedImage,
    PullToRefreshDirective,
    ElasticScrollDirective,
    OverlayPanelDirective,
    FitLevelDirective,
    PrimaryNavArrowKeysDirective,
    ModalOverlayDirective,
    MorphOverlayDirective,
    MobileNavModule,
    ButtonsModule,
    VaultDuplicateItemsDialogComponent,
    VaultTypeGenericComponent,
    VaultTypeTransactionComponent,
    VaultTypeSourceTransactionComponent,
    VaultTypeAccountComponent,
    AccountRowSkeletonComponent,
    LoadingAnnouncerComponent,
    LargeAmountComponent,
    GlossScrollComponent,
    LinkTypeBadgeComponent,
  ],
  declarations: [
    ChatbotComponent,
    EmptyStateComponent,
    RecurringDetectorComponent,
    RecurringDetectorDetailDialogComponent,
    SymbolIconRendererComponent,
    RdDescriptionRendererComponent,
    RdAvgAmountRendererComponent,
    RdNextDueRendererComponent,
    RdStatusRendererComponent,
    RdActionRendererComponent,
    RdChangeRendererComponent,
    AdvancedFeaturesComponent,
    NotificationsComponent,
    BillAlertDialogComponent,
    ConfirmationDialogComponent,
    StatusHeaderComponent,
    AlertDialogComponent,
    VerifyEmailRemindDialogComponent,
    PluginDetailsDialogComponent,
    WealthComparisonDialogComponent,
    EditToolsDialogComponent,
    CouponDetailsDialogComponent,
    ApiKeyComponent,
    ChangeEmailComponent,
    ChangeKdfComponent,
    ChangePasswordComponent,
    EmergencyAccessComponent,
    ManageSecurityComponent,
    DeauthorizeSessionsComponent,
    DeleteAccountComponent,
    FrontendLayoutComponent,
    IosRedemptionBoxComponent,
    HintComponent,
    LockComponent,
    ViewsControlComponent,
    ViewsCustomizeComponent,
    PastViewsDatepickerComponent,
    FutureViewsDatepickerComponent,
    TodayViewsDatepickerComponent,
    CabinetDatepickerComponent,
    GeneratorComponent,
    PasswordGeneratorHistoryComponent,
    UserVerificationPromptComponent,
    PreferencesComponent,
    ProfileComponent,
    ProvidersComponent,
    PurgeVaultComponent,
    AcceptEmergencyComponent,
    RecoverDeleteComponent,
    RecoverTwoFactorComponent,
    RemovePasswordComponent,
    SecurityKeysComponent,
    SetPasswordComponent,
    FirstDeviceSetupComponent,
    DeviceApprovalRequiredComponent,
    PendingDeviceApprovalDialogComponent,
    SettingsComponent,
    SettingsRouteComponent,
    UserAccessPageComponent,
    TaxInfoComponent,
    ToolsComponent,
    TaskInfoTooltipsComponent,
    GuideSuccessToastComponent,
    TwoFactorAuthenticatorComponent,
    TwoFactorComponent,
    TwoFactorEmailComponent,
    TwoFactorManageComponent,
    TwoFactorOptionsComponent,
    TwoFactorRecoveryComponent,
    TwoFactorSetupComponent,
    TwoFactorVerifyComponent,
    TwoFactorWebAuthnComponent,
    TwoFactorYubiKeyComponent,
    UpdateKeyComponent,
    UpdateLicenseComponent,
    UpdatePasswordComponent,
    UserLayoutComponent,
    UserVerificationComponent,
    VaultTimeoutInputComponent,
    VerifyEmailComponent,
    VerifyEmailTokenComponent,
    EditBalanceComponent,
    BookPipe,
    EstimatePipe,
    SafeHtmlPipe,
    CapitalisePipe,
    MacroNumberPipe,
    AsterisksPipe,
    StorageLimitPipe,
    CategoryPipe,
    ClassificationPipe,
    HelpTooltipComponent,
    EstimateTypeRecurringComponent,
    EstimateTypeRevaluationComponent,
    EstimateTypeInterestComponent,
    EstimateTypeTransactionComponent,
    EstimateFormComponent,
    CalendarComponent,
    DatePickerComponent,
    EstimatesComponent,
    EstimatesAddEditComponent,
    SpinnerComponent,
    MainProgressBarComponent,
    BasiqProgressBarComponent,
    ProgressBarComponent,
    ManagePreferencesComponent,
    AutoCreditRedemptionToggleComponent,
    ManageCategoriesComponent,
    CategoriesAddEditComponent,
    CollapsibleCardComponent,
    TotalCreditsDisplayComponent,
    PlatinumCardComponent,
    PointsRedemptionComponent,
    AmazonGiftCardComponent,
    PointsPurchaseComponent,
    CreditsAddedComponent,
    PurchaseProcessingComponent,
    RecentActivityComponent,
    AdListComponent,
    DesktopAdModalComponent,
    RedemptionConfirmationComponent,
    TabButtonComponent,
    ConversionConfirmationComponent,
    ClassificationAddEditComponent,
    ManageClassificationsComponent,
    ClassificationsDetailsComponent,
    BookCellRenderer,
    RedactionDescriptionRenderer,
    EarnComponent,
    VarianceCellRenderer,
    ManageCellRendererComponent,
    CheckboxHeaderRenderer,
    CheckboxCellRenderer,
    SelectAllHeaderRenderer,
    RedactionPublishDateRenderer,
    VersionStateCellRenderer,
    CategoryCellRenderer,
    ClassificationCellRenderer,
    InAmountCellRenderer,
    OutAmountCellRenderer,
    NormalizedInAmountCellRenderer,
    NormalizedOutAmountCellRenderer,
    AggregateAmountCellRenderer,
    AccountActionButtonsCellRenderer,
    ScenarioDifferenceMessageComponent,
    BalanceCellRenderer,
    CheckBoxCellRenderer,
    SyncStatusRendererComponent,
    TransactionDateCellRender,
    NoRowsOverlayComponentOfDashTable,
    ProductCellRenderer,
    PresetDateRangeComponent,
    CalloutComponent,
    CallToPremiumComponent,
    AccountAddEditComponent,
    CabinetFileUploadComponent,
    StatementImportMappingComponent,
    EditCabinetComponent,
    FilePreviewComponent,
    FileFullPreviewComponent,
    AccountTypeComponent,
    AccountSyncComponent,
    AccountRegionsComponent,
    AccountDetailsComponent,
    AccountListItemComponent,
    AccountOverviewHeroComponent,
    AccountOverviewStripComponent,
    SelectionPointerComponent,
    AccountLinkedCollectionComponent,
    ShareAccountComponent,
    BudgetDetailsComponent,
    BudgetProgressBarComponent,
    CabinetDetailsComponent,
    CategoriesDetailsComponent,
    AccountFormComponent,
    CabinetFormComponent,
    AccountBalanceComponent,
    TransactionComponent,
    ManageAccountsComponent,
    BudgetComponent,
    CreditsComponent,
    HelpGuideComponent,
    GuideComponent,
    CouponCardComponent,
    CouponsComponent,
    PluginsComponent,
    GlossGroceryComponent,
    RenameListDialogComponent,
    CabinetComponent,
    CreateAndPublishComponent,
    VersionHistoryComponent,
    ManageSymbolsComponent,
    ManageInstitutionsComponent,
    ManageSourceExplorerComponent,
    AutoRedemptionTestPanelComponent,
    DateFormatPipe,
    ReferenceDataImportComponent,
    BalanceChartComponent,
    BalanceHudComponent,
    ScenarioChartComponent,
    ScenarioHudComponent,
    BestScenarioDialogComponent,
    MonthlySummaryDialogComponent,
    GroceryHelpDialogComponent,
    GroceryRowActionsSheetComponent,
    BubbleChartComponent,
    ContributionGraphComponent,
    BestScenarioCarouselItemComponent,
    OpenAccountCardComponent,
    FulfillConditionsComponent,
    TitleComponent,
    BestAccountTooltipComponent,
    TooltipCardComponent,
    MoveAssetComponent,
    OpenAccountComponent,
    EarningsCardComponent,
    StepperEarningsCardComponent,
    EarningsHeaderComponent,
    EarningsFooterComponent,
    EarningsContentComponent,
    CarouselEarningsCardComponent,
    CarouselRateConditionComponent,
    StepperComponent,
    StepIndicatorComponent,
    CarouselComponent,
    BestInterestAccountComponent,
    CtaNotificationComponent,
    ComingSoonPageComponent,
    WizardStepperComponent,
    ItemDisplayComponent,
    AutoCompleteTransactionDirectionComponent,
    DisplayTransactionsComponent,
    TabsWrapperComponent,
    AddEditTransactionFormComponent,
    AddBalanceWizardComponent,
    FileDetailsStageComponent,
    SelectAccountStageComponent,
    AddTransactionStageComponent,
    AccordionComponent,
    CountriesComponent,
    CurrenciesComponent,
    PriceDetailsComponent,
    SymbolDetailsComponent,
    InstitutionDetailsComponent,
    AddSymbolFormComponent,
    AddBudgetFormComponent,
    AutoBudgetPreviewDialogComponent,
    EditSymbolFormComponent,
    InstitutionFormComponent,
    GlossInputComponent,
    InputComponent,
    DropdownSelectComponent,
    DropdownSearchComponent,
    DropdownMultiselectComponent,
    CategorySelectComponent,
    DateFieldComponent,
    DropdownExpandComponent,
    PasswordInputComponent,
    InstitutionalAccountsComponent,
    ViewsDropdownComponent,
    SideMenuComponent,
    MenuToggleComponent,
    ScrollArrowsComponent,
    AppMenuComponent,
    SearchBarComponent,
    SignalGlowWrapperComponent,
    NumberRollUpWrapperComponent,
    OdometerNumberComponent,
    CardGlareComponent,
    PathTabsInfoComponent,
    GlossButtonComponent,
    RemoveBasiqConsentComponent,
    RemoveFiskilConsentComponent,
    ConfirmConsentRemovalComponent,
    ManuallyAddInstitutionComponent,
    HelpBoxComponent,
    TransactionDetailsComponent,
    LinkTransactionPickerComponent,
    EditTransactionDetailsComponent,
    BalanceAlignmentTransactionComponent,
    StatementBalanceDetailsComponent,
    RevaluationTransactionComponent,
    ModalHeaderComponent,
    BankIconsComponent,
    InstalledPluginCardComponent,
    SearchInputComponent,
    PluginConfigComponent,
    TileButtonComponent,
    UserLocationComponent,
    FileUploadComponent,
    ModalFooterComponent,
    TooltipIconComponent,
    RadioButtonComponent,
    PathTabsComponent,
    NavPanelComponent,
    ToggleSwitchComponent,
    SwitchToggleComponent,
    CurrencyAmountInputComponent,
    VersionGroupCellRenderer,
    CheckboxComponent,
    FilterSectionComponent,
    PluginCardComponent,
    ViewsComponent,
    AccountsFilterComponent,
    AccountIconRendererComponent,
    TransactionDescriptionCellRenderer,
    BudgetNameRendererComponent,
    PastGroupHeaderComponent,
    AmountRendererComponent,
    BalanceDetailsRendererComponent,
    TransactionInfoPanelComponent,
    TableCellNameRendererComponent,
    CategoryItemRenderComponent,
    CategorySourceRendererComponent,
    CategorySourceBadgeComponent,
    ClassificationItemRenderComponent,
    AccountStatusRendererComponent,
    SymbolRateRendererComponent,
    ChevronCellRenderer,
    AgGridTableComponent,
    WidgetComponent,
    LoadingOverlayComponent,
    CurrentBalanceComponent,
    GroupByChartControlComponent,
    DialogWrapperComponent,
    DetailsWrapperComponent,
    PlansComponent,
    PlansFilterComponent,
    PlanDetailsDialogComponent,
    ChangePlanDialogComponent,
    SubscriptionPageComponent,
    StorageComponent,
    MeterComponent,
    PremiumCalloutComponent,
    PageWrapperComponent,
    KeychainComponent,
    CreateCollectionComponent,
    OrganizationPageComponent,
    AcceptTeamComponent,
    TeamDetailComponent,
    TeamsInfoPanelComponent,
  ],
  exports: [
    CouponDetailsDialogComponent,
    ConfirmConsentRemovalComponent,
    ManuallyAddInstitutionComponent,
    PluginConfigComponent,
    RemoveBasiqConsentComponent,
    RemoveFiskilConsentComponent,
    ApiKeyComponent,
    ChangeEmailComponent,
    ChangeKdfComponent,
    ChangePasswordComponent,
    EmergencyAccessComponent,
    ManageSecurityComponent,
    AdvancedFeaturesComponent,
    NotificationsComponent,
    BillAlertDialogComponent,
    ConfirmationDialogComponent,
    StatusHeaderComponent,
    AlertDialogComponent,
    VerifyEmailRemindDialogComponent,
    DeauthorizeSessionsComponent,
    DeleteAccountComponent,
    FrontendLayoutComponent,
    HintComponent,
    IosRedemptionBoxComponent,
    LockComponent,
    ViewsControlComponent,
    ViewsCustomizeComponent,
    PastViewsDatepickerComponent,
    FutureViewsDatepickerComponent,
    TodayViewsDatepickerComponent,
    CabinetDatepickerComponent,
    GeneratorComponent,
    PasswordGeneratorHistoryComponent,
    PreferencesComponent,
    ProfileComponent,
    ProvidersComponent,
    PurgeVaultComponent,
    AcceptEmergencyComponent,
    RecoverDeleteComponent,
    RecoverTwoFactorComponent,
    RemovePasswordComponent,
    SecurityKeysComponent,
    SetPasswordComponent,
    FirstDeviceSetupComponent,
    DeviceApprovalRequiredComponent,
    PendingDeviceApprovalDialogComponent,
    SettingsComponent,
    UserAccessPageComponent,
    TaxInfoComponent,
    ToolsComponent,
    TaskInfoTooltipsComponent,
    GuideSuccessToastComponent,
    TwoFactorAuthenticatorComponent,
    TwoFactorComponent,
    TwoFactorEmailComponent,
    TwoFactorManageComponent,
    TwoFactorOptionsComponent,
    TwoFactorRecoveryComponent,
    TwoFactorSetupComponent,
    TwoFactorVerifyComponent,
    TwoFactorWebAuthnComponent,
    TwoFactorYubiKeyComponent,
    UpdateKeyComponent,
    UpdateLicenseComponent,
    UpdatePasswordComponent,
    UserLayoutComponent,
    UserVerificationComponent,
    VaultTimeoutInputComponent,
    VerifyEmailComponent,
    VerifyEmailTokenComponent,
    EditBalanceComponent,
    HelpTooltipComponent,
    BookPipe,
    EstimatePipe,
    SafeHtmlPipe,
    CategoryPipe,
    ClassificationPipe,
    EstimateTypeRecurringComponent,
    EstimateTypeRevaluationComponent,
    EstimateTypeInterestComponent,
    EstimateTypeTransactionComponent,
    EstimateFormComponent,
    CalendarComponent,
    DatePickerComponent,
    EstimatesComponent,
    EstimatesAddEditComponent,
    SpinnerComponent,
    ManagePreferencesComponent,
    AutoCreditRedemptionToggleComponent,
    VaultTypeAccountComponent,
    VaultTypeSourceTransactionComponent,
    VaultTypeTransactionComponent,
    ManageCategoriesComponent,
    CategoriesAddEditComponent,
    CollapsibleCardComponent,
    TotalCreditsDisplayComponent,
    PlatinumCardComponent,
    PointsRedemptionComponent,
    AmazonGiftCardComponent,
    PointsPurchaseComponent,
    CreditsAddedComponent,
    PurchaseProcessingComponent,
    RecentActivityComponent,
    AdListComponent,
    DesktopAdModalComponent,
    RedemptionConfirmationComponent,
    TabButtonComponent,
    ConversionConfirmationComponent,
    ClassificationAddEditComponent,
    BookCellRenderer,
    RedactionDescriptionRenderer,
    EarnComponent,
    VarianceCellRenderer,
    ManageCellRendererComponent,
    CheckboxHeaderRenderer,
    CheckboxCellRenderer,
    SelectAllHeaderRenderer,
    RedactionPublishDateRenderer,
    VersionGroupCellRenderer,
    VersionStateCellRenderer,
    CategoryCellRenderer,
    ClassificationCellRenderer,
    InAmountCellRenderer,
    OutAmountCellRenderer,
    NormalizedInAmountCellRenderer,
    NormalizedOutAmountCellRenderer,
    AggregateAmountCellRenderer,
    AccountActionButtonsCellRenderer,
    ScenarioDifferenceMessageComponent,
    BalanceCellRenderer,
    CheckBoxCellRenderer,
    SyncStatusRendererComponent,
    TransactionDateCellRender,
    NoRowsOverlayComponentOfDashTable,
    ProductCellRenderer,
    ManageClassificationsComponent,
    ClassificationsDetailsComponent,
    PresetDateRangeComponent,
    CalloutComponent,
    CallToPremiumComponent,
    AccountAddEditComponent,
    CabinetFileUploadComponent,
    StatementImportMappingComponent,
    EditCabinetComponent,
    FilePreviewComponent,
    FileFullPreviewComponent,
    AccountTypeComponent,
    AccountSyncComponent,
    AccountRegionsComponent,
    AccountDetailsComponent,
    AccountListItemComponent,
    AccountOverviewHeroComponent,
    AccountOverviewStripComponent,
    SelectionPointerComponent,
    AccountLinkedCollectionComponent,
    ShareAccountComponent,
    BudgetDetailsComponent,
    BudgetProgressBarComponent,
    CabinetDetailsComponent,
    CategoriesDetailsComponent,
    AccountFormComponent,
    CabinetFormComponent,
    AccountBalanceComponent,
    TransactionComponent,
    ManageAccountsComponent,
    BudgetComponent,
    CreditsComponent,
    HelpGuideComponent,
    GuideComponent,
    PluginsComponent,
    GlossGroceryComponent,
    RenameListDialogComponent,
    CabinetComponent,
    CreateAndPublishComponent,
    VersionHistoryComponent,
    ManageSymbolsComponent,
    ManageInstitutionsComponent,
    ManageSourceExplorerComponent,
    AutoRedemptionTestPanelComponent,
    DateFormatPipe,
    ReferenceDataImportComponent,
    MainProgressBarComponent,
    BasiqProgressBarComponent,
    ProgressBarComponent,
    BalanceChartComponent,
    BalanceHudComponent,
    ScenarioChartComponent,
    ScenarioHudComponent,
    BestScenarioDialogComponent,
    MonthlySummaryDialogComponent,
    GroceryHelpDialogComponent,
    GroceryRowActionsSheetComponent,
    BubbleChartComponent,
    ContributionGraphComponent,
    BestScenarioCarouselItemComponent,
    OpenAccountCardComponent,
    FulfillConditionsComponent,
    TitleComponent,
    BestAccountTooltipComponent,
    TooltipCardComponent,
    MoveAssetComponent,
    OpenAccountComponent,
    EarningsCardComponent,
    StepperEarningsCardComponent,
    EarningsHeaderComponent,
    EarningsFooterComponent,
    EarningsContentComponent,
    CarouselEarningsCardComponent,
    CarouselRateConditionComponent,
    WizardStepperComponent,
    StepIndicatorComponent,
    CarouselComponent,
    BestInterestAccountComponent,
    CtaNotificationComponent,
    GlossInputComponent,
    InputComponent,
    DropdownSelectComponent,
    DropdownSearchComponent,
    DropdownMultiselectComponent,
    CategorySelectComponent,
    DateFieldComponent,
    DropdownExpandComponent,
    PasswordInputComponent,
    CountriesComponent,
    CurrenciesComponent,
    PriceDetailsComponent,
    SymbolDetailsComponent,
    InstitutionDetailsComponent,
    AddSymbolFormComponent,
    AddBudgetFormComponent,
    AutoBudgetPreviewDialogComponent,
    ViewsDropdownComponent,
    ComingSoonPageComponent,
    StepperComponent,
    ItemDisplayComponent,
    AutoCompleteTransactionDirectionComponent,
    DisplayTransactionsComponent,
    TabsWrapperComponent,
    AddEditTransactionFormComponent,
    AddBalanceWizardComponent,
    FileDetailsStageComponent,
    SelectAccountStageComponent,
    AddTransactionStageComponent,
    AccordionComponent,
    InstitutionalAccountsComponent,
    SideMenuComponent,
    MenuToggleComponent,
    ScrollArrowsComponent,
    SearchBarComponent,
    SignalGlowWrapperComponent,
    NumberRollUpWrapperComponent,
    OdometerNumberComponent,
    CardGlareComponent,
    PathTabsInfoComponent,
    GlossButtonComponent,
    SettingsComponent,
    HelpBoxComponent,
    TransactionDetailsComponent,
    LinkTransactionPickerComponent,
    EditTransactionDetailsComponent,
    BalanceAlignmentTransactionComponent,
    StatementBalanceDetailsComponent,
    RevaluationTransactionComponent,
    FileUploadComponent,
    ModalHeaderComponent,
    TileButtonComponent,
    ButtonsModule,
    UserLocationComponent,
    ToggleSwitchComponent,
    SwitchToggleComponent,
    CheckboxComponent,
    FilterSectionComponent,
    PluginCardComponent,
    ViewsComponent,
    AccountsFilterComponent,
    AccountIconRendererComponent,
    TransactionDescriptionCellRenderer,
    BudgetNameRendererComponent,
    PastGroupHeaderComponent,
    AmountRendererComponent,
    BalanceDetailsRendererComponent,
    RdDescriptionRendererComponent,
    RdAvgAmountRendererComponent,
    RdNextDueRendererComponent,
    RdStatusRendererComponent,
    RdActionRendererComponent,
    RdChangeRendererComponent,
    TableCellNameRendererComponent,
    CategoryItemRenderComponent,
    CategorySourceRendererComponent,
    CategorySourceBadgeComponent,
    ClassificationItemRenderComponent,
    AccountStatusRendererComponent,
    SymbolRateRendererComponent,
    ChevronCellRenderer,
    AgGridTableComponent,
    CurrentBalanceComponent,
    GroupByChartControlComponent,
    DialogWrapperComponent,
    DetailsWrapperComponent,
    PlansComponent,
    PlansFilterComponent,
    PlanDetailsDialogComponent,
    ChangePlanDialogComponent,
    SubscriptionPageComponent,
    StorageComponent,
    MeterComponent,
    PremiumCalloutComponent,
    PageWrapperComponent,
    KeychainComponent,
    ChatbotComponent,
    EmptyStateComponent,
    CreateCollectionComponent,
    OrganizationPageComponent,
    RecurringDetectorComponent,
    RecurringDetectorDetailDialogComponent,
    AcceptTeamComponent,
    TeamDetailComponent,
    TeamsInfoPanelComponent,
  ],
})
export class LooseComponentsModule {}
